import { React, useState } from 'react';
import { useHistory } from 'react-router-dom';
import {
  Box,
  TextField,
  Button,
  Typography,
  Grid,
  Paper,
  InputAdornment,
  FormControlLabel,
  Switch,
} from '@mui/material';
import { Controller, useForm } from 'react-hook-form';
import { LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import dayjs, { Dayjs } from 'dayjs';
import { DesktopDatePicker } from '@mui/x-date-pickers/DesktopDatePicker';
import AddIcCallIcon from '@mui/icons-material/AddIcCall';
import PersonIcon from '@mui/icons-material/Person';
import thLocale from 'date-fns/locale/th';

const CustomerGold = ({ control, data, watch }) => {
  const history = useHistory();
  const [namecus, setNamecus] = useState();
  const [showTaxField, setShowTaxField] = useState(false);

  return (
    <Paper
      elevation={16}
      sx={{
        padding: 4,
        maxWidth: 600,
        margin: 'auto',
        marginTop: 5,
      }}
      square={false}
    >
      <Typography variant="h6" gutterBottom>
        ข้อมูลลูกค้า
      </Typography>
      <Box
        component="form"
        sx={{
          display: 'flex',
          flexDirection: 'column',
          gap: 2,
        }}
        noValidate
        autoComplete="off"
      >
        <Grid container spacing={2}>
          <Grid item xs={12} md={6}>
            <Controller
              control={control}
              name="name"
              render={({ field }) => (
                <TextField
                  {...field}
                  fullWidth
                  label="ชื่อ-สกุล"
                  variant="outlined"
                  placeholder="ชื่อ-สกุล"
                  // onChange={(e) => setNamecus(e.target.value)}
                />
              )}
            />
          </Grid>
          <Grid item xs={12} md={6}>
            <Controller
              control={control}
              name="cardID"
              render={({ field }) => (
                <TextField
                  {...field}
                  fullWidth
                  label="เลขบัตรประจำตัวประชาชน"
                  variant="outlined"
                  placeholder="เลขบัตรประจำตัวประชาชน"
                  type="tel"
                  InputProps={{
                    startAdornment: (
                      <InputAdornment position="start">
                        <PersonIcon />
                      </InputAdornment>
                    ),
                    inputMode: 'numeric',
                  }}
                  inputProps={{
                    maxLength: 13,
                    minLength: 13,
                  }}
                  onInput={(e) => {
                    e.target.value = e.target.value.replace(/[^0-9]/g, '');
                  }}
                />
              )}
            />
          </Grid>
        </Grid>
        <Grid container spacing={2}>
          <Grid item xs={12} md={6}>
            <Controller
              control={control}
              name="born"
              defaultValue={dayjs().format('MM/DD/YY')}
              render={({ field }) => (
                <LocalizationProvider
                  dateAdapter={AdapterDayjs}
                  locale={thLocale}
                >
                  <DesktopDatePicker
                    label="วันเกิด"
                    inputFormat="DD/MM/YYYY"
                    {...field}
                    renderInput={(params) => (
                      <TextField {...params} fullWidth />
                    )}
                  />
                </LocalizationProvider>
              )}
            />
          </Grid>
          <Grid item xs={12} md={6}>
            <Controller
              control={control}
              name="tel"
              render={({ field }) => (
                <TextField
                  {...field}
                  fullWidth
                  label="เบอร์โทรศัพท์"
                  variant="outlined"
                  placeholder="เบอร์โทรศัพท์"
                  type="tel"
                  InputProps={{
                    startAdornment: (
                      <InputAdornment position="start">
                        <AddIcCallIcon />
                      </InputAdornment>
                    ),
                    inputMode: 'numeric',
                  }}
                  inputProps={{
                    maxLength: 10,
                  }}
                  onInput={(e) => {
                    e.target.value = e.target.value.replace(/[^0-9]/g, '');
                  }}
                />
              )}
            />
          </Grid>
        </Grid>
        <Controller
          control={control}
          name="address"
          render={({ field }) => (
            <TextField
              {...field}
              fullWidth
              label="ที่อยู่"
              variant="outlined"
              placeholder="ที่อยู่"
              multiline
              rows={4}
            />
          )}
        />
        <Grid container spacing={2}>
          <Grid item xs={12} md={6}>
            <Controller
              control={control}
              name="social.line"
              render={({ field }) => (
                <TextField
                  {...field}
                  fullWidth
                  label="Line ID"
                  variant="outlined"
                  placeholder="Line ID"
                  // onChange={(e) => setNamecus(e.target.value)}
                />
              )}
            />
          </Grid>
          <Grid item xs={12} md={6}>
            <Controller
              control={control}
              name="social.facebook"
              render={({ field }) => (
                <TextField
                  {...field}
                  fullWidth
                  label="Facebook"
                  variant="outlined"
                  placeholder="Facebook"
                  // onChange={(e) => setNamecus(e.target.value)}
                />
              )}
            />
          </Grid>
        </Grid>
        <Grid container spacing={2}>
          <Grid item xs={12} md={6}>
            <Controller
              control={control}
              name="social.email"
              render={({ field }) => (
                <TextField
                  {...field}
                  fullWidth
                  label="Email"
                  variant="outlined"
                  placeholder="Email"
                  type="email"
                  // onChange={(e) => setNamecus(e.target.value)}
                />
              )}
            />
          </Grid>
          <Grid item xs={12} md={6}>
            <Controller
              control={control}
              name="job"
              render={({ field }) => (
                <TextField
                  {...field}
                  fullWidth
                  label="อาชีพ"
                  variant="outlined"
                  placeholder="อาชีพ"
                  // onChange={(e) => setNamecus(e.target.value)}
                />
              )}
            />
          </Grid>
        </Grid>
        <FormControlLabel
          control={
            <Switch
              checked={showTaxField}
              onChange={(e) => setShowTaxField(e.target.checked)}
              color="primary"
            />
          }
          label="ต้องการระบุเลขผู้เสียภาษี"
        />

        {/* Conditionally show tax number input */}
        {showTaxField && (
          <Controller
            control={control}
            name="tax.taxnumber"
            render={({ field }) => (
              <TextField
                {...field}
                fullWidth
                label="เลขผู้เสียภาษี"
                variant="outlined"
                placeholder="เลขผู้เสียภาษี"
                type="tel"
                InputProps={{
                  inputMode: 'numeric',
                }}
                inputProps={{
                  maxLength: 13,
                  minLength: 13,
                }}
                onInput={(e) => {
                  e.target.value = e.target.value.replace(/[^0-9]/g, '');
                }}
              />
            )}
          />
        )}
      </Box>
    </Paper>
  );
};

export default CustomerGold;
